import { useTranslation } from "react-i18next";
import React from "react";
import { Card, LineChartOutlined, Skeleton, Table } from "src/assets/imports/antdComponents";
import { ICustSkeletonProps } from "./interface";

const CustSkeleton: React.FC<ICustSkeletonProps> = ({ type, rows, style, className }) => {
	const { t } = useTranslation();
	const commonProps = {
		style,
		className,
	};

	switch (type) {
		case "chart":
			return (
				<Skeleton.Node {...commonProps} active className="notes-analysis-longitudinal-chart-loader">
					<LineChartOutlined style={{ fontSize: 100, color: "#bfbfbf" }} />
				</Skeleton.Node>
			);
		case "card":
			return <Card {...commonProps} loading />;
		case "form":
			return <Skeleton {...commonProps} active title={false} paragraph={{ rows: rows, width: "100%" }} />;
		case "table":
			return (
				<Table
					{...commonProps}
					loading={true}
					locale={{
						emptyText: t("Loading..."),
					}}
				/>
			);
		default:
			return <Skeleton {...commonProps} active paragraph={{ rows: rows, width: "100%", style: rows === 0 ? { margin: 0 } : undefined }} />;
	}
};

export default CustSkeleton;
